import React, {Component} from "react";
import PropTypes from "prop-types";
import each from "lodash/each";

const fetch = window.fetch;
const Error = window.Error;

/**
 * Handles fetching the packages file.
 * Also handles printing error messages from fetching.
 * When an error happens, the whole app is bypassed.
 */
const withProvider = (Wrapped) =>
	class extends Component {
		constructor(props) {
			super(props);
			this.state = {
				channels: [],
				channel: null,
				packages: null,
				error: null
			};
		}

		getChildContext() {
			return {
				data: this.state.packages,
			};
		}

		fetch(url) {
			return fetch(url)
				.then((response) => {
					if (!response["ok"] || response["status"] >= 400) {
						return Promise.reject(
							new Error(`Could not fetch package manifest. (${response["status"]}: ${response["statusTest"]})`)
						);
					}
					
					return response;
				})
				.then((response) => {
					return response.json()
						.catch((error) => Promise.reject(
							new Error(`Could not parse JSON file.\n\n${error.toString()}`)
						))
					;
				})
			;
		}

		componentWillMount() {
			this.fetch(window.packages_channels)
				.then((channels) => {
					const channel = channels[0];
					this.setState({channels});
					if (!this.state["channel"]) {
						this.setState({channel});
					}
				})
			;
		}

		componentWillUpdate(nextProps, nextState) {
			// Reacts on channel change.
			if (nextState["channel"] !== this.state["channel"]) {
				const {channel} = nextState;
				this.fetchChannel(channel);
			}
		}

		fetchChannel(channel) {
			this.setState({packages: null});
			// FIXME : Configure ability to use `.json.gz` file.
			const channelFile = `packages-${channel}.json`;
			this.fetch(channelFile)
				.then((data) => {
					// Adds attribute to the data.
					each(data["packages"], (pkg, attribute) => pkg["attribute"] = attribute);

					return data;
				})
				.then((packages) => window.packages = packages)
				.then((packages) => this.setState({packages}))
				.catch((error) => {
					this.setState({error});
				})
			;
		}

		handleChannelChange(channel) {
			this.setState({channel});
		}

		render() {
			const {error} = this.state;
			if (error) {
				return (
					<div>
						<h3>The NixOS packages explorer could not load package informations...</h3>
						<p>
							Here's what happened:
						</p>
						<pre>
							{error.toString()}
						</pre>
					</div>
				);
			}
			const {channel, channels, packages} = this.state;

			return <Wrapped
				data={packages}
				channel={channel}
				channels={channels}
				onChannelChange={(e) => this.handleChannelChange(e)}
				{...this.props}
			/>;
		}

		static childContextTypes = {
			data: PropTypes.object,
		}
	}
;

export default withProvider;



// WEBPACK FOOTER //
// ./src/packages_provider.js